import { SignalPlatformName } from 'app/signals/types'

export interface RelatedEntry {
  id: string
  name: string
  platform: SignalPlatformName | 'dv360'
}

// Platform relations reference external audiences, not Innkeepr signal IDs.
export const getRelatedEntries = (relations: unknown): RelatedEntry[] => {
  if (!relations || typeof relations !== 'object') return []
  const entries: RelatedEntry[] = []
  const add = (value: unknown, platform: RelatedEntry['platform']) => {
    if (!value || typeof value !== 'object') return
    if ('name' in value && typeof value.name === 'string') {
      const id =
        'externalId' in value
          ? value.externalId
          : 'userList' in value
            ? value.userList
            : 'firstPartyAndPartnerAudienceId' in value
              ? value.firstPartyAndPartnerAudienceId
              : value.name
      entries.push({ id: String(id), name: value.name, platform })
    }
    if ('lookalikes' in value && Array.isArray(value.lookalikes)) {
      value.lookalikes.forEach((lookalike: unknown) => add(lookalike, platform))
    }
  }
  for (const platform of ['facebook', 'tiktok', 'criteo', 'googleAdwords', 'dv360'] as const) {
    if (!(platform in relations)) continue
    const value: unknown = Reflect.get(relations, platform)
    if (Array.isArray(value)) value.forEach((entry: unknown) => add(entry, platform))
    else add(value, platform)
  }
  return entries
}
